import { connect } from 'react-redux'
import AgreementModal from '../components/agreement-modal';
import {showModal} from '../action-creators/get-agreement';
import {toggleIAgree} from '../action-creators/get-agreement';

const mapDispatchToProps = (dispatch, props) => ({
    showModal: () => dispatch(showModal('')),
    showButton: () => dispatch(toggleIAgree(''))
});

const mapStateToProps =(state) => {
   console.log(`mapStateToProps -> ${JSON.stringify(state.agreementdata)}`);
      return {
          show:state.agreementdata.show,
          toggleOn:state.agreementdata.toggleOn
             }; 
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AgreementModal);
